import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
} from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import style from '../MissionSettingsModal.module.css'

const ScheduleSettings = () => {
  const [weekdaysChecked, setWeekdaysChecked] = useState(false)
  const [date, setDate] = useState(new Date())
  const { t } = useTranslation()

  return (
    <Accordion>
      <AccordionSummary>{t('scheduleSettings.schedule')}</AccordionSummary>
      <AccordionDetails>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Stack>
            <DateTimePicker
              label={t('scheduleSettings.chooseDateAndTime')}
              value={date}
              onChange={e => {
                setDate(e || new Date())
              }}
              renderInput={(params: any) => <TextField style={{ maxWidth: '30vh' }} {...params} />}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={weekdaysChecked}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setWeekdaysChecked(event.target.checked)
                  }}
                />
              }
              label={t('scheduleSettings.setCleaningSchedule')}
              sx={{ paddingTop: 3 }}
            />
          </Stack>
          {weekdaysChecked && (
            <div className={style.weekdays}>
              <FormControlLabel control={<Switch defaultChecked />} label={t('global.sunday')} />
              <FormControlLabel control={<Switch />} label={t('global.monday')} />
              <FormControlLabel control={<Switch />} label={t('global.tuesday')} />
              <FormControlLabel control={<Switch />} label={t('global.wednesday')} />
              <FormControlLabel control={<Switch />} label={t('global.thursday')} />
              <FormControlLabel control={<Switch />} label={t('global.friday')} />
              <FormControlLabel control={<Switch />} label={t('global.saturday')} />
            </div>
          )}
        </LocalizationProvider>
      </AccordionDetails>
    </Accordion>
  )
}

export default ScheduleSettings
